import { render, staticRenderFns } from "./SchattingList.vue?vue&type=template&id=78b82811"
import script from "./SchattingList.vue?vue&type=script&lang=js"
export * from "./SchattingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports